import type { ModuleManifest } from '../types.js'

/*
 * BI — бизнесийн шинжилгээний самбар. Домэйн бүр нэг A4 хуудас, хуудас дээр
 * хэрэглэгч өөрөө график хавтангуудыг өрж, зөөж, чартын төрлийг нь сольж,
 * байрлалаа хадгална ([[apps/admin/src/views/apps/bi/types.ts]] — гэрээ).
 *
 * ! ЭНЭ МОДУЛЬ ӨӨРИЙН БИЗНЕСИЙН ӨГӨГДӨЛГҮЙ. Тоонууд нь `erp`, `warehouse`, `delivery`,
 * ! `hr` модулиудын API-гаас уншигдана — BI нь тэдгээрийн дээрх ХАРАГДАЦ.
 * ! Ү5-аас (docs/31 §4o) ЗӨВХӨН өрөлт/харагдацын хүснэгт (`bi_user_boards`,
 * ! `bi_shared_boards`, `bi_saved_views`) ба `apps/api/src/bi-boards/`, `bi-export/`
 * ! бий — тоо тооцоолдог BI контроллер ХЭВЭЭР алга, `resources` хоосон.
 *
 * ! Домэйн тус бүрд ТУСДАА ЭРХ ЗАРЛААГҮЙ (`bi.sales:show` гэх мэт). Шалтгаан:
 * ! BI-ийн тоо бүр эх модулийнхаа эрхээр аль хэдийн хаалттай — борлуулалтын
 * ! дүн харах эрхгүй хүнд BI-гийн борлуулалтын хавтан ХООСОН ирнэ. Домэйнөөр
 * ! эрх нэмбэл тэр нь хоёр дахь, зөрүүтэй үнэн үүсгэх ба [[03-modules]]-д
 * ! «ямар ч үр дагваргүй эрх» устгагдсан түүх бий.
 */
export const biModule = {
  key: 'bi',
  name: 'BI',
  description:
    'Борлуулалт, агуулах, түгээлт, санхүү, хүний нөөцийн үзүүлэлтүүд — A4 ' +
    'хуудсан дээр хэрэглэгч өөрөө өрдөг график самбар.',

  /*
   * 0.1.0 — хөгжүүлэлтийн шатанд. Бүрэн болоход 1.0.0 болно ([[delivery]] ижил).
   */
  version: '0.1.0',
  icon: 'ChartNoAxesCombinedIcon',

  /*
   * ! АСААЛТТАЙ — `delivery`, `warehouse`, `crm`-ээс ЗОРИУД ялгаатай.
   *
   * Тэр гурав нь ҮЙЛ АЖИЛЛАГААНЫ модуль: цэсэнд гарах нь «машин хуваарилж,
   * бэлтгэл хийж чадна» гэсэн амлалт болох тул дуусаагүй байхад харагдах нь
   * эндүүрэл төрүүлнэ. BI нь ЗӨВХӨН ХАРАГДАЦ — `create`/`delete` эрхгүй,
   * өөрийн API-гүй, өөрийн хүснэгтгүй. Хоосон хавтан нь юу ч амлахгүй,
   * харин модулийг нуух нь өдөр бүр ашиглах самбарыг тохиргооны дор булна.
   *
   * ! Энэ утга нь ЗӨВХӨН ШИНЭ СУУЛГАЦЫНХ. Модулийн мөр нэг удаа үүссэний
   * ! дараа Тохиргоо ▸ Модулиуд дээрх сэлгүүр л шийднэ — seed ч, boot дээрх
   * ! тааруулалт ч түүнийг буцаан дарахгүй (`modules.service.ts`).
   */
  enabledByDefault: true,

  permissions: [
    /*
     * ! ГУРВАН ЭРХ (Ү5-аас).
     *
     * `show` — самбар нээж харах. `manage` — хавтан нэмэх, зөөх, чартын
     * төрөл солих, ӨӨРИЙН байрлалыг серверт ХАДГАЛАХ. `publish` — бүх хүний
     * анхдагч өрөлтийг нийтлэх (доор).
     *
     * ! Харах ба засах нь ҮНЭХЭЭР өөр: самбарын өрөлт нь нийтийн харагдац
     * ! тул засварлах эрхийг бүгдэд өгвөл нэг хүний зөөсөн хавтан бусдын
     * ! хуудсыг өөрчилнө. Хадгалалт хэрэглэгч бүрээр явах үед ч `manage`
     * ! утгаа алдахгүй — хэвлэх загварын үндсэн өрөлтийг тэр эрх л тогтооно.
     */
    { resource: 'bi.boards', action: 'show', description: 'BI самбар харах' },
    { resource: 'bi.boards', action: 'manage', description: 'BI самбарын өрөлт засах, хадгалах' },

    /*
     * ! Ү5 (docs/46 Q6, docs/31 §4o): НИЙТЛЭГДСЭН АНХДАГЧ өрөлтийг нийтлэх/цуцлах. `manage`-ээс ТУСДАА:
     * ! `manage` нь хүн бүрийн ӨӨРИЙН өрөлт (серверт `PUT /me/bi-boards`), `publish` нь БҮХ хүний анхдагч —
     * ! нэг хүний туршилт бусдын самбарыг өөрчлөхгүйн тулд. `admin`/`super-admin` seed-ээр авна
     * ! (`release.sh` бүрд `db:seed`); бизнесийн дүрд /settings/roles-оос олгоно. Аудит: `bi.board.publish`.
     */
    { resource: 'bi.boards', action: 'publish', description: 'BI самбарын анхдагч өрөлтийг бүх хэрэглэгчид нийтлэх' },

    /*
     * ! Ү7 (docs/46 §9 Ү7, D7-2; docs/31 §4t): PRO ТҮВШИН — мөнгөн дүн, хүн/багийн гүйцэтгэл, төлөвлөгөө-гүйцэтгэл, санхүүгийн
     * ! домэйн. ҮНЭН ХААЛГА СЕРВЕРТ (`BiTierInterceptor` + `packages/platform-contract/src/bi-tier.ts`): эрхгүй хүнд мөнгө
     * ! `null` + `redacted`, хүн/баг/төлөвлөгөө/санхүү 403 `BI_PRO_REQUIRED`. Эх жагсаалтын эрхийг ОРЛОХГҮЙ — Pro хавтан ч
     * ! эх эрхээ (`erp.reports:list`, `erp.credit:list` …) шаардсаар. `admin`/`super-admin` seed-ээр; бизнесийн «Удирдлага»
     * ! дүрд /settings/roles-оос. PIN-ийн жагсаалтад ОРОХГҮЙ (эмзэг — мөнгө).
     */
    { resource: 'bi.pro', action: 'show', description: 'BI Pro түвшин — мөнгөн дүн, баг/хүний гүйцэтгэл, төлөвлөгөө, санхүү' },

    /*
     * ! Ү8 (docs/31 §4u, D8-2…D8-4): МЕНЕЖЕР ТҮВШИН — мөнгө ЗӨВХӨН хэрэглэгчид хуваарилагдсан БОРЛУУЛАЛТЫН СУВГИЙН хүрээнд
     * ! (борлуулалт, санхүү; баг/хүний задаргаа ч сувгийн дотор). Суваггүй бол Basic + «суваг тохируулаагүй» мэдэгдэл —
     * ! компанийн нийт мөнгө ХЭЗЭЭ Ч гарахгүй (fail-closed). Эх эрхийг ОРЛОХГҮЙ (`erp.reports:aggregate`, `erp.credit:aggregate` …).
     * ! `admin`/`super-admin` seed-ээр; бизнест `sales-manager` дүр. PIN-ийн жагсаалтад ОРОХГҮЙ.
     */
    {
      resource: 'bi.manager',
      action: 'show',
      description: 'BI Менежер түвшин — өөрийн борлуулалтын сувгийн мөнгөн дүн, багийн гүйцэтгэл, авлага, төлбөр',
    },
  ],

  navigation: [
    {
      /*
       * НЭГ БҮЛЭГ, таван мөр. Дэд цэс (children) болгоогүй: цэс нь нэг
       * модулиар хүрээлэгддэг тул BI-г сонгосон хүн зөвхөн эдгээр таван
       * мөрийг хардаг — задардаг цэс нэмэлт дарах алхам болохоос өөр юу ч
       * нуухгүй ([[coresoft-module-scoped-sidebar]]).
       *
       * ! Дарааллыг БҮҮ ХОЛИ: жагсаалтын ЭХНИЙ мөр нь модулийн «буух хуудас»
       * ! болдог (`navDestinations[].landing`) — сэлгэгчээс BI сонгоход
       * ! хэрэглэгч тийш очно.
       */
      label: 'BI',
      items: [
        {
          label: 'Борлуулалт',
          href: '/bi/sales',
          icon: 'ShoppingCartIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'bi.boards:show',
        },
        {
          label: 'Агуулах',
          href: '/bi/warehouse',
          icon: 'WarehouseIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'bi.boards:show',
        },
        {
          label: 'Түгээлт',
          href: '/bi/delivery',
          icon: 'TruckIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'bi.boards:show',
        },
        {
          label: 'Санхүү',
          href: '/bi/finance',
          icon: 'BanknoteIcon',
          iconClassName: 'text-indigo-600 dark:text-indigo-400',
          permission: 'bi.boards:show',
        },
        {
          label: 'Хүний нөөц',
          href: '/bi/hr',
          icon: 'UsersRoundIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'bi.boards:show',
        },
      ],
    },
  ],

  /*
   * ! REFINE-ИЙН RESOURCE ЗАРЛААГҮЙ.
   *
   * Resource-ийн цорын ганц үүрэг нь data provider-т `<нэр> → API зам`
   * хөрвүүлэлт өгөх явдал. BI-ийн хавтангууд нь эх модулиудын байгаа
   * цэгүүдээс (`erp/*`, `hr/*` …) уншдаг тул `bi/...` гэсэн зам БАЙХГҮЙ —
   * зарлавал 404 руу заасан хуурамч resource үлдэнэ ([[crm]] ижил шийдэл).
   *
   * ! Самбарын ӨРӨЛТ (Ү5) — өөрийн цэгүүд, Refine resource БИШ (data provider-оор
   * ! дамждаггүй, `apps/admin/src/views/apps/bi/persist/*` шууд дуудна):
   * !   `GET|PUT|DELETE /me/bi-boards/:domain` — хувийн өрөлт (`show` / `manage`);
   * !   `GET|PUT|DELETE /bi/boards/:domain/published` — нийтлэгдсэн анхдагч (`show` / `publish`);
   * !   `GET|POST|PATCH|DELETE /me/bi-views/:domain[/:id]` — нэртэй харагдац (`show`);
   * !   `POST /bi/export/xlsx` — дэлгэцийн хүснэгтээс Excel (`show` + `erp.reports:list`).
   * ! Эдгээр нь ӨРӨЛТ/ХАРАГДАЦ — бизнесийн өгөгдөл биш; тоо эх модулийн эрхээр хэвээр (D0 (А)).
   * ! Гэрээ: `packages/platform-contract/src/bi.ts`.
   */
  resources: [],
} as const satisfies ModuleManifest
